export function RootLayout({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
